
import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';


const handlerVideo = (idContainer: string) => {
  const container = document.getElementById(idContainer);

  const previewContainer = container?.querySelector(".artisan__video-preview") as HTMLDivElement;

  const playButton = container?.querySelector("button");
  const youtubePlayer = container?.querySelector("iframe")?.contentWindow;

  playButton?.addEventListener("click", () => {
    // Enviar mensaje a iframe para reproducir
    youtubePlayer?.postMessage(
      JSON.stringify({
        event: "command",
        func: "playVideo",
      }),
      "*"
    );
  });


  window.addEventListener("message", (event) => {
    try {
      if (typeof event.data !== "string") {
        return;
      }

      const data = JSON.parse(event.data);

      if (data.event === "infoDelivery" && typeof data.info?.playerState !== "undefined") {
        const playerState = data.info.playerState;

        if (playerState === 1) {
          // Video reproduciéndose
          previewContainer &&  (previewContainer.style.display = "none");
        } else if (playerState === 0) {
          // Video terminado
          previewContainer &&  (previewContainer.style.display = "block");
        }
      }
    } catch (error) {
      console.error("Error procesando mensaje del iframe:", error);
    }
  });
}

const initCardSlider = () => {
  console.log("Cargando slider 11112-----");
  
  var swiper = new Swiper(".bannercard__slides", {
    centeredSlides: false,
    slidesPerView: 1,
    spaceBetween: 10,

    pagination: {
      el: ".swiper-banner-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-banner-button-next",
      prevEl: ".swiper-banner-button-prev",
    },
  });
};

(function page() {
  // initCardSlider();
  handlerVideo("videoHomeBanner");
})();
